import {
  itemsAutoStock,
  itemsWithBatch,
  purchasesCodes,
} from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import { getPrefix } from "../../../../utils/getPrefix";
import { createCommision } from "../commissions/createCommision";
import { getPriceOrOffer } from "../getPriceOrOffer";
import { updateCheckStock } from "./updateCheckStock";

const returnValue = (code: string, { data, docValues, user }: stdObject) => {
  const { type, person, items } = docValues;
  switch (code) {
    case "SER":
      return docValues.data[`SER${type}`].value;
    case "COD":
      return docValues.data[`COD${type}`].value;
    case "LIN":
      return items.length + 1;
    case "ART":
      return data.CODART;
    case "NOM":
      return data.NOMART;
    case "PEN":
      return [2, 3].includes(user.STOROL) &&
        itemsAutoStock.includes(data.TIPART)
        ? 1
        : 0;
    case "CAN":
      return 1;
    case "IMP":
      return data.TAX[user.CODPAI] ?? 0;
    case "PCO":
      return data.PREPCO[user.CODPAI] ?? 0;
    case "PRE":
    case "TOT":
      if (purchasesCodes.includes(type)) {
        return data.PREPCO[user.CODPAI] ?? 0;
      } else {
        const rate = person?.TARCLI ?? 1;
        const price =
          user.CODPAI in data.PREART && rate in data.PREART[user.CODPAI]
            ? data.PREART[user.CODPAI][rate].PRELTA
            : 0;
        return getPriceOrOffer({
          data,
          price,
          country: user.CODPAI,
          rate,
        });
      }
    // case "HUE":
    //   return data.SERART ? uuidv4() : "";
    case "ANE":
    case "BUL":
    case "CBU":
    case "COL":
    case "CPA":
    case "CRE":
    case "DES":
    case "ENS":
    case "KIT":
    case "TIP":
      return 0;
    default:
      return "";
  }
};

export const updateItemDocData = async ({
  data,
  docValues,
  user,
  items,
  setMsg,
  setModalData,
  setWindowValues,
  setDocValues,
  countTotals,
  logoutAction,
}: stdObject) => {
  const { type, itemCodes, staff } = docValues;
  const newItew = itemCodes.reduce((acc: stdObject, key: string) => {
    const artCode = getPrefix(key);
    acc[key] = returnValue(artCode, { data, docValues, user });
    return acc;
  }, {});

  Object.keys(staff).forEach((e: string) => {
    if (Number(staff[e].value) > 0) {
      const newComm: boolean | stdObject = createCommision({
        id: staff[e].value,
        name: staff[e].name,
        group: Number(e),
        itemCode: data.CODART,
        item: data,
        data: newItew,
        docValues,
      });
      if (typeof newComm === "object") {
        docValues.commissions.push(newComm);
      }
    }
  });

  docValues.items.push(newItew);

  if (itemsWithBatch.includes(data.TIPART) && [2, 3].includes(user.STOROL)) {
    docValues = await updateCheckStock(
      docValues.items.length - 1,
      type === "TRA" && user.CODSUC !== docValues.data[`SER${type}`].value,
      true,
      {
        returnData: true,
        user,
        items,
        docValues,
        setDocValues,
        setMsg,
        setModalData,
        setWindowValues,
        logoutAction,
      },
    );
  }
  countTotals(docValues);
};
